<!--  -->
<template>
  <div class="">
    <div class="top-bg"></div>
    <div class="bottom-bg"></div>
    <maps ref="maps" :zoom="15"></maps>
    <!-- <div class="group-list" style="top: 200px" @click="openFertilizationAnalysis">施肥分析</div> -->
    <div class="group-list" @click="openGroup">水阀分组</div>
    <div
      class="add-group"
      @click="addGroupMarker"
      v-if="markersTypeId == 2 && !openWaterGroup"
    >
      设置水阀分组
    </div>
    <div
      class="add-group"
      @click="closeWaterGroup"
      v-if="markersTypeId == 2 && openWaterGroup"
    >
      完成水阀分组
    </div>
    <div class="flex alit justb top-data">
      <div class="flexCol alit" style="width: 30%">
        <div class="top-data-text1">
          占地面积<a style="font-size: 14px">(亩)</a>
        </div>
        <div class="top-data-text2">3426.83</div>
      </div>
      <div class="flexCol alit" style="width: 30%">
        <div class="top-data-text1">
          物联设备<a style="font-size: 14px">(台)</a>
        </div>
        <div class="top-data-text2">678</div>
      </div>
      <div class="flexCol alit" style="width: 30%">
        <div class="top-data-text1">
          物资用量<a style="font-size: 14px">(吨)</a>
        </div>
        <div class="top-data-text2">232</div>
      </div>
    </div>
    <div class="flex alit justb bottom-data">
      <div
        class="flexCol alit"
        style="position: relative"
        v-for="item in deviceCount"
        :key="item.title"
      >
        <div
          class="device-list"
          :style="{ backgroundImage: `url(${item.bg})` }"
          @click="getMarkers(item.id)"
        >
          <div class="device-num">
            {{ item.num }} <a style="font-size: 16px" v-if="item.id == 2">套</a
            ><a style="font-size: 16px" v-else>个</a>
          </div>
          <div class="device-title">{{ item.title }}</div>
        </div>
        <img
          class="zhixiang"
          v-if="markersTypeId == item.id"
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%8C%87%E5%90%91%402x.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import maps from "../mapNew.vue";
export default {
  components: { maps },
  data() {
    return {
      markersTypeId: "",
      openWaterGroup: false,
      deviceCount: [
        {
          bg: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/intelligentControl/%E6%B0%B4%E9%98%80%402x.png",
          title: "水阀",
          num: "629",
          id: 2,
        },
        {
          bg: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/intelligentControl/%E6%B0%B4%E8%82%A5%402x.png",
          title: "水肥机",
          num: "4",
          id: 1,
        },
        {
          bg: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/intelligentControl/%E8%8B%97%E6%83%85%402x%20%281%29.png",
          title: "苗情检测仪",
          num: "10",
          id: 3,
        },
        {
          bg: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E8%99%AB%E6%83%85%E6%A3%80%E6%B5%8B%E4%BB%AA.png",
          title: "虫情检测仪",
          num: "1",
          id: 7,
        },
        {
          bg: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/intelligentControl/%E5%A2%92%E6%83%85%402x%20%281%29.png",
          title: "墒情检测仪",
          num: "1",
          id: 5,
        },
        {
          bg: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E6%9D%80%E8%99%AB%E7%81%AF.png",
          title: "杀虫灯",
          num: "15",
          id: 8,
        },
        {
          bg: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E5%AD%A2%E5%AD%90%E6%A3%80%E6%B5%8B%E4%BB%AA.png",
          title: "孢子检测仪",
          num: "1",
          id: 6,
        },
        {
          bg: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/intelligentControl/%E6%B0%94%E8%B1%A1%E6%A3%80%E6%B5%8B%E4%BB%AA%402x.png",
          title: "气象站",
          num: "1",
          id: 4,
        },
      ],
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    openFertilizationAnalysis(){
      this.$router.push('/fertilizationAnalysis')
    },
    openGroup() {
      this.$refs.maps.closeGroupMarkers();
    },
    closeWaterGroup() {
      this.openWaterGroup = false;
      this.$refs.maps.closeGroupMarkers();
      this.$message({
        message: "暂无操作权限",
        type: "warning",
      });
    },
    //开启水阀分组 点击水阀可进行设置连线
    addGroupMarker() {
      this.$confirm(
        "请按照顺序点击水阀进行分组。 注:已分组水阀不可再次分组",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showCancelButton: false,
          type: "warning",
        }
      )
        .then(() => {
          this.openWaterGroup = true;
          this.$refs.maps.openGroupMarkers();
        })
        .catch(() => {});
    },
    getMarkers(e) {
      this.markersTypeId = e;
      this.$request("iot/device/list?type=" + e).then((res) => {
        this.$refs.maps.setMarkers(res);
      });
    },
    getDeviceCount() {
      this.$request("iot/device/count").then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          // 1水肥 2水阀 3监控 4 气象 5 土壤 6 孢子 7 虫情监测仪 8 虫情灯
          switch (res.data[i].type) {
            case 1:
              // this.deviceCount[1].num = res.data[i].deviceCount;
              break;
            case 2:
              // this.deviceCount[0].num = res.data[i].deviceCount;
              break;
            case 3:
              this.deviceCount[2].num = res.data[i].deviceCount;
              break;
            case 4:
              this.deviceCount[7].num = res.data[i].deviceCount;
              break;
            case 5:
              this.deviceCount[4].num = res.data[i].deviceCount;
              break;
            case 6:
              this.deviceCount[6].num = res.data[i].deviceCount;
              break;
            case 7:
              this.deviceCount[3].num = res.data[i].deviceCount;
              break;
            case 8:
              this.deviceCount[5].num = res.data[i].deviceCount;
              break;
            default:
              break;
          }
        }
      });
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getDeviceCount()
    setTimeout(() => {
      this.getMarkers("");
    }, 2000);
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
.zhixiang {
  width: 58px;
  height: 58px;
  position: absolute;
  bottom: -50px;
}
.group-list {
  width: 130px;
  height: 36px;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/button%402x.png");
  background-size: 100% 100%;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
  line-height: 36px;
  text-align: center;
  position: fixed;
  top: 130px;
  right: 100px;
  z-index: 99;
  cursor: pointer;
}
.add-group {
  width: 130px;
  height: 36px;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/button%402x.png");
  background-size: 100% 100%;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
  line-height: 36px;
  text-align: center;
  position: fixed;
  top: 130px;
  right: 240px;
  z-index: 99;
  cursor: pointer;
}
.bottom-data {
  position: fixed;
  bottom: 5vh;
  z-index: 99;
  width: 80vw;
  margin-left: 10vw;

  .device-list {
    width: 180px;
    height: 80px;
    background-size: 100% 100%;
    margin-top: 25px;
    cursor: pointer;

    .device-num {
      font-family: DINAlternateBold;
      font-size: 26px;
      color: #ffffff;
      margin: 2px 0 8px 75px;
    }

    .device-title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 20px;
      color: #ffffff;
      margin-left: 75px;
    }
  }
}

.top-data {
  width: 36vw;
  position: fixed;
  top: 115px;
  left: 32vw;
  z-index: 99;
  pointer-events: none;

  .top-data-text1 {
    font-weight: 600;
    font-size: 18px;
    color: #addaff;
  }

  .top-data-text2 {
    font-family: YouSheBiaoTiHei;
    font-size: 39px;
    color: #fab040;
  }
}
</style>
